import React from "react";
import { Button, Icon } from "@ui-component-library";
import styled from "styled-components";

export const BackButton = ({ handleBack, hide }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <BackContainer>
      {!hide &&
        (isMobile ? (
          <Button variant="tertiary" size="icon" aria-label="Tillbaka" onClick={handleBack}>
            <Icon name="ChevronDownSimple" size="large" className="rotate-90" />
          </Button>
        ) : (
          <Button
            onClick={handleBack}
            variant="tertiary"
          >
            <Icon name="ChevronDownSimple" className="rotate-90" />
            Tillbaka
          </Button>
        ))}
    </BackContainer>
  );
};

export const CloseButton = ({ handleClose }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <CloseContainer>
      {isMobile ? (
        <Button variant="tertiary" size="icon" aria-label="Stäng" onClick={handleClose}>
          <Icon name="CrossSimple" size="large" />
        </Button>
      ) : (
        <Button
          onClick={handleClose}
          variant="tertiary"
        >
          Stäng
          <Icon name="CrossSimple" />
        </Button>
      )}
    </CloseContainer>
  );
};

const BackContainer = styled.div`
  min-width: 107px;
  display: flex;
  justify-content: start;
  min-width: 107px;

  @media (max-width: 767px) {
    min-width: 44px;
  }
`;

const CloseContainer = styled.div`
  min-width: 107px;
  display: flex;
  justify-content: end;
  min-width: 107px;

  @media (max-width: 767px) {
    min-width: 44px;
  }
`;
